// @flow
import type { UserState } from './index'
import * as mutationTypes from './mutation-types'

export default {
  [mutationTypes.SET_TOKEN]: (state: UserState, token: ?string) => {
    state.token = token
  },
  [mutationTypes.DELETE_TOKEN]: (state: UserState) => {
    state.token = null
  },
  [mutationTypes.SET_PASSWORD_RESET_TOKEN]: (state: UserState, token: string) => {
    state.passwordResetToken = token
  },
  [mutationTypes.DELETE_PASSWORD_RESET_TOKEN]: (state: UserState) => {
    state.passwordResetToken = ''
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js